export function isoDateToAu(isoDate: string | null | undefined): string {
  const raw = (isoDate ?? "").trim();
  if (!raw) return "-";

  // Expecting "YYYY-MM-DD" (what we store in the UI + send to API)
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(raw);
  if (!match) return raw;

  const [, yyyy, mm, dd] = match;
  return `${dd}/${mm}/${yyyy}`;
}

export function isoDateToDate(isoDate: string | null | undefined): Date | null {
  const raw = (isoDate ?? "").trim();
  if (!raw) return null;
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(raw);
  if (!match) return null;
  const [, yyyy, mm, dd] = match;
  const year = Number(yyyy);
  const monthIndex = Number(mm) - 1;
  const day = Number(dd);
  const date = new Date(year, monthIndex, day);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function dateToIsoDate(value: Date | null): string {
  if (!value) return "";
  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, "0");
  const day = String(value.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

